import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_app/settings/')({
  component: () => <Navigate to="/settings/documents" replace />,
})
